import {
  BrochureCTA,
  FloatingSection,
  Header,
  Intro,
  KitchenExploreCTA,
  NewsWidget,
  PartnerTicker,
  QuickLinks,
} from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";

export default function PrivateDevelopers() {
  return (
    <div>
      <Header
        title="Contract Kitchens for the UK’s Discerning Property Developers"
        bgColor="black"
        className="text-white"
        image={t(routes.privateDevelopers, "image")}
      >
        <p>
          From conception to cost analysis, we can guide you through the process
          of optimising the layout of your project’s kitchens, to maximise buyer
          appeal.
        </p>
        <p>
          Working from your tender pack and specification requirements, we will
          produce fully costed plans and elevations in a range of price groups.
        </p>
      </Header>
      <Intro
        title="Once you have fixed your budgets, we will work with you to style and accessorise each kitchen for all house types within each tenure to best suit the needs of your future homeowner or tenant."
        bgColor="black"
      />
      <PartnerTicker />
      <div className="mt-10 space-y-20">
        <FloatingSection
          bgColor="white"
          image="media/assets/private-developers-contract-kitchens.jpg"
          imageClassName="bg-top"
          title={
            <>
              <h3 className="text-lg font-light">Our market-leading service</h3>
              <p className="font-medium">
                Our site service includes a dedicated contract manager, who will
                plot measure and check the readiness of each plot for call-off.
              </p>
            </>
          }
        >
          <p>
            Working to a 4–6 week call-off period, your kitchens will be
            delivered nationwide by our own fleet of HVO-powered trucks and
            unpacked at each plot by our employed teams of unloaders.{" "}
          </p>
          <p>
            Our installation teams, who are FIRA-accredited installers, will
            work collaboratively with your site teams to ensure that
            installations are completed and signed-off in accordance with your
            site protocols.
          </p>
        </FloatingSection>
        <FloatingSection
          reverse
          image="media/assets/private-developers-item-2.jpg"
          imageClassName="bg-bottom"
          title={
            <>
              <h3 className="text-lg font-light">Why work with us?</h3>
              <p className="font-medium">
                We have over 70 years of experience in supplying contract
                kitchens to the UK’s leading house builders. Our customer care
                and service levels are unrivalled in the industry, making Paula
                Rosa Manhattan the perfect partner to fulfil your kitchen
                packages.
              </p>
            </>
          }
        >
          <p>
            We have strong relationships with all major appliance, sink and tap
            manufacturers and we can supply a full range of worktops from
            laminate to composite and stone.
          </p>
          <p>
            Our factory and headquarters are based in Sussex, and we would be
            delighted to welcome you to view our production facilities, design
            lab and our newly refurbished showroom.
          </p>
          <p>
            Our range of contemporary and traditional kitchen doors suits all
            housing developments. Whether your project is for luxury homes or
            for first-time buyers, we have a price group to suit you.
          </p>
        </FloatingSection>
      </div>
      <BrochureCTA
        text="A partner you can rely on. Find out more about how we work with private developers, view the latest trends and peruse our ranges in detail."
        image="/media/assets/brochure-developers.jpg"
        link="https://issuu.com/paularosamanhattan/docs/housebuilder?mode=window"
      />
      <KitchenExploreCTA />
      <QuickLinks />
      <NewsWidget source="/news/case-studies" tag="private" />
    </div>
  );
}
